module.exports = __webpack_public_path__ + "img/9_15.fdbd3680.png";